import { faCircleInfo } from "@jewlr/pro-light-svg-icons/faCircleInfo"
// import { faTag } from "@jewlr/pro-regular-svg-icons/faTag"
import { useCallback } from "react"
import { useSelector } from "react-redux"

import { openModal } from "components/modal"
import Button from "components/ui/button"
import FontAwesomeIcon from "components/ui/font-awesome-icon"
import Shimmer from "components/ui/shimmer"
import { IS_AU, IS_CA, isTestMode, IS_JEWLR } from "helpers/application"
import { to_currency } from "helpers/number"
import { cn } from "styles/utils"

import PriceBadge from "./wizard-header/price-badge"

const ProductPrice = () => {
  const pricing = useSelector((state) => state.wizard.price_and_promo)
  const wizardLoading = useSelector((state) => state.wizard.loading)
  const onSale = pricing && pricing.on_sale

  const loading = !Object.keys(pricing).length || wizardLoading

  // const percentageSavings = (
  //   ((pricing.retail_price - pricing.price_to_display) * 100) /
  //   pricing.retail_price
  // ).toFixed(0)

  const currencyCode = IS_AU() ? "AU" : IS_CA() ? "C" : ""

  const handleHonestPricingClick = useCallback(() => {
    openModal("#honest-pricing")
    if (!isTestMode) {
      dataLayer.push({
        event: "opened-pdp-honest-pricing-popup",
      })
    }
  }, [])

  if (pricing.price_to_display <= 0) {
    return null
  }

  const globaleAttrs = {
    container: {},
    display: {},
    reg: {},
  }
  if (sl.config.global_e_pricing == "fixed") {
    if (onSale) {
      globaleAttrs.reg["data-fp"] =
        `"{${sl.config.site_country_for_analytics}": "${pricing.regular_pricing}"}`

      globaleAttrs.display["data-fp"] =
        `{"${sl.config.site_country_for_analytics}": "${pricing.price_to_display}"}`
    } else {
      globaleAttrs.display["data-fp"] =
        `{"${sl.config.site_country_for_analytics}": "${pricing.regular_pricing}"}`
    }
  } else {
    globaleAttrs.container["data-ge-product-container"] = true
    if (onSale) {
      globaleAttrs.reg["data-ge-list-price"] = true
      globaleAttrs.display["data-ge-sale-price"] = true
    } else {
      globaleAttrs.display["data-ge-price"] = true
    }
  }
  return (
    <div className="tablet:mb-10 mb-8 flex flex-col items-start gap-10">
      {loading ? (
        <Shimmer className="h-26 w-1/2" />
      ) : (
        <div
          className={cn(
            "text-24 leading-26 flex items-center gap-8 font-semibold"
          )}
          {...globaleAttrs.container}
        >
          <h2
            data-cy="product-item-price"
            data-ge-parentproduct-total-price
            {...globaleAttrs.display}
          >
            {currencyCode}
            {to_currency(pricing.price_to_display)}
          </h2>
          {onSale && (
            <del className="text-grey-300" {...globaleAttrs.reg}>
              {currencyCode}
              {to_currency(pricing.regular_pricing)}
            </del>
          )}
          {onSale && <PriceBadge />}
        </div>
      )}
      {IS_JEWLR() &&
        (loading ? (
          <Shimmer className="h-12 w-2/5" />
        ) : (
          <Button
            aria-label={`Compare to estimated retail price ${to_currency(
              pricing.retail_price
            )}. Read more about our value pricing`}
            onClick={handleHonestPricingClick}
          >
            <p className="text-10 leading-12 font-semibold uppercase -tracking-tight">
              Estimated Retail Price {to_currency(pricing.retail_price)}
            </p>
            <FontAwesomeIcon className="text-10 ml-4" icon={faCircleInfo} />
          </Button>
        ))}
      {/* {new Date().setHours(0, 0, 0, 0) <=
        new Date(pricing.sale_ends).setHours(0, 0, 0, 0) && (
        <p className="text-grey-500 text-12 mt-4">
          Sale ends {pricing.sale_ends}
        </p>
      )} */}
    </div>
  )
}

export default ProductPrice
